import React from 'react';

import { KeyOutlined, LockOutlined, SafetyOutlined, IdcardOutlined } from '@ant-design/icons';
import { Form, Input, Switch, Select, Row, Col } from 'antd';
import { useTranslation } from 'react-i18next';

import { useDirtyMaskedField } from '@hooks/shared/useDirtyMaskedField';

const MomoCredentials = ({ form, ecAccount }) => {
  const { t } = useTranslation();

  const isEditing = !!ecAccount?.id;
  const entpPwdDirty = useDirtyMaskedField(form, [ 'credentials', 'entp_pwd' ], isEditing);
  const pdfPasswordDirty = useDirtyMaskedField(form, [ 'credentials', 'pdf_password' ], isEditing);

  return (
    <div>
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            name={['credentials', 'entp_id']}
            label={t('models.ec_account.platform_settings.momo.entp_id')}
            rules={[{ required: true, message: t('models.ec_account.platform_settings.momo.entp_id_required') }]}
          >
            <Input
              placeholder={t('models.ec_account.platform_settings.momo.entp_id_placeholder')}
              prefix={<SafetyOutlined />}
            />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item
            name={['credentials', 'entp_code']}
            label={t('models.ec_account.platform_settings.momo.entp_code')}
            rules={[{ required: true, message: t('models.ec_account.platform_settings.momo.entp_code_required') }]}
          >
            <Input
              placeholder={t('models.ec_account.platform_settings.momo.entp_code_placeholder')}
              prefix={<IdcardOutlined />}
            />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item
            name={['credentials', 'entp_pwd']}
            label={t('models.ec_account.platform_settings.momo.entp_pwd')}
            rules={[{ required: true, message: t('models.ec_account.platform_settings.momo.entp_pwd_required') }]}
          >
            <Input.Password
              autoComplete="new-password"
              placeholder={t('models.ec_account.platform_settings.momo.entp_pwd_placeholder')}
              prefix={<LockOutlined />}
              visibilityToggle={entpPwdDirty}
            />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item
            name={['credentials', 'otp_back_no']}
            label={t('models.ec_account.platform_settings.momo.otp_back_no')}
            rules={[{ required: true, message: t('models.ec_account.platform_settings.momo.otp_back_no_required') }]}
          >
            <Input
              placeholder={t('models.ec_account.platform_settings.momo.otp_back_no_placeholder')}
              prefix={<KeyOutlined />}
            />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item
            name={['credentials', 'pdf_password']}
            label={t('models.ec_account.platform_settings.momo.pdf_password')}
          >
            <Input.Password
              autoComplete="new-password"
              placeholder={t('models.ec_account.platform_settings.momo.pdf_password_placeholder')}
              prefix={<LockOutlined />}
              visibilityToggle={pdfPasswordDirty}
            />
          </Form.Item>
        </Col>


      </Row>
    </div>
  );
};

export default MomoCredentials;
